/** Turn a `snake_case` key into a Title Case label: "pending_approval" → "Pending Approval". */
export function snakeToTitleCase(value: string): string {
  return value
    .split('_')
    .map((part) => (part ? `${part[0].toUpperCase()}${part.slice(1).toLowerCase()}` : part))
    .join(' ');
}
